// extracted by mini-css-extract-plugin
export default {"container":"Card_container__K7EcC","title":"Card_title__fjt9r","info":"Card_info__fIRs3"};